export const GLOBAL_SEARCH_RESULT_URL_PATH = '/global-tires-pagination'
export const RECORDS_PER_PAGE = 12
export const GLOBAL_SEARCH_COMPONENT = 'BOTGlobalSearch'
export const GLOBAL_TIRE_SEARCH_REGEX = /\/global-search\/tires/
